// ................regulator fillings tabs..............................
export const REGULATOR_TABS = [
  { label: "CEP", value: "cep" },
  { label: "US DMF", value: "us_dmf" },
  { label: "KDMF", value: "kdmf" },
  { label: "JDMF", value: "jdmf" },
  { label: "CDMF", value: "cdmf" },
  { label: "WC", value: "wc" },
];

// ................import export tabs..............................
export const IMPORT_EXPORT_TABS = [
  { label: "Indian Exports", value: "indian_exports" },
  { label: "Indian Imports", value: "indian_imports" },
  { label: "Mexican Exports", value: "mexican_exports" },
  { label: "Mexican Imports", value: "mexican_imports" },
  { label: "Brazilian Exports", value: "brazilian_exports" },
  { label: "Brazilian Imports", value: "brazilian_imports" },
];

// ................other insights tabs..............................
export const OTHER_INSIGHTS_TABS = [
  { label: "Global Consumption", value: "global_consumption" },
  { label: "FDF US Approvals", value: "fdf_us_approvals" },
  { label: "FDF Worldwide", value: "fdf_worldwide" },
];
